import useReveal from "@/lib/useReveal";
import { SITE } from "@/lib/site";

export default function Privacy() {
  useReveal();
  return (
    <main data-testid="page-privacy">
      <section className="pt-16 md:pt-20 pb-10 md:pb-14 bg-gradient-to-b from-navy-50/40 to-transparent">
        <div className="container-narrow">
          <div className="text-[12px] tracking-[0.22em] uppercase text-gold-500 font-medium reveal">Privacy Notice</div>
          <h1 className="font-serif-display text-4xl md:text-6xl text-navy-800 mt-3 leading-[1.04] tracking-tight reveal">
            How we handle your information.
          </h1>
          <p className="mt-5 max-w-3xl text-slate-600 text-[17px] leading-relaxed reveal">
            This Privacy Notice explains what information St. John Accounting & Tax collects through this website, how it is used, and the steps we take to safeguard it.
          </p>
        </div>
      </section>

      <section className="py-10 md:py-16">
        <div className="container-narrow max-w-3xl text-slate-700 text-[16px] leading-[1.8] space-y-8 reveal">
          <div>
            <h2 className="font-serif-display text-2xl text-navy-800">Information collected through this website</h2>
            <p className="mt-3">The only information collected directly through this website is what you choose to submit through the Contact form: your name, email address, phone number (optional), subject, and message. Submissions are stored on our secure servers and emailed to our office so we can respond.</p>
            <p className="mt-3"><strong>Please do not include Social Security numbers, dates of birth, driver's license numbers, bank account or routing numbers, income amounts, or copies of tax returns in the Contact form.</strong> If we need that information to serve you, we will arrange a secure method to collect it.</p>
          </div>

          <div>
            <h2 className="font-serif-display text-2xl text-navy-800">How your information is used</h2>
            <ul className="list-disc pl-6 mt-3 space-y-1.5">
              <li>To respond to your inquiry and schedule follow-up.</li>
              <li>To deliver the services you request.</li>
              <li>To meet legal, regulatory, and professional obligations (including IRS Circular 230 and the Oklahoma Board of Accountancy).</li>
            </ul>
            <p className="mt-3">We do not sell your information. We do not share it with third parties for marketing purposes.</p>
          </div>

          <div>
            <h2 className="font-serif-display text-2xl text-navy-800">Information security</h2>
            <p className="mt-3">St. John Accounting & Tax maintains administrative, technical, and physical safeguards designed to protect client information, consistent with the standards expected of tax and accounting professionals under the IRS Safeguarding Taxpayer Data guidance (IRS Publication 4557 / Publication 5708) and the FTC Safeguards Rule as applicable to our firm.</p>
            <p className="mt-3">Sensitive personal and financial information (Social Security numbers, bank information, tax documents, etc.) is handled through secure, firm-approved channels. Please contact our office at <a className="text-navy-800 underline decoration-gold-400/60" href={SITE.phoneTel}>{SITE.phone}</a> to arrange secure document delivery. Do not transmit sensitive documents through ordinary email, text message, or this website's Contact form.</p>
          </div>

          <div>
            <h2 className="font-serif-display text-2xl text-navy-800">Cookies and tracking</h2>
            <p className="mt-3">This website does not use advertising cookies, third-party analytics trackers, or marketing pixels. Google Fonts is loaded to render typography; this may result in a request to Google's servers for font files. Standard web server logs may record IP address and browser information for security and troubleshooting.</p>
          </div>

          <div>
            <h2 className="font-serif-display text-2xl text-navy-800">Children's privacy</h2>
            <p className="mt-3">This website is intended for adults seeking accounting and tax services. We do not knowingly collect information from children under 13.</p>
          </div>

          <div>
            <h2 className="font-serif-display text-2xl text-navy-800">External links</h2>
            <p className="mt-3">Our site links to external resources such as irs.gov, the Oklahoma Tax Commission, and our sister firms. We are not responsible for the privacy practices or content of external sites.</p>
          </div>

          <div>
            <h2 className="font-serif-display text-2xl text-navy-800">Changes to this notice</h2>
            <p className="mt-3">We may update this notice from time to time. The most current version will always be posted on this page.</p>
          </div>

          <div>
            <h2 className="font-serif-display text-2xl text-navy-800">Contact us</h2>
            <p className="mt-3">For questions about this Privacy Notice or how your information is handled, please contact David St. John at <a className="text-navy-800 underline decoration-gold-400/60" href={`mailto:${SITE.email}`}>{SITE.email}</a> or {SITE.phone}.</p>
          </div>

          <p className="text-slate-500 text-[13.5px] pt-6 border-t border-navy-100">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}.</p>
        </div>
      </section>
    </main>
  );
}
